import { SvgIcon, SvgIconProps } from "@mui/joy";
import { forwardRef } from "react";

const TickedCircle = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="16" rx="8" fill="#45D27E" />
        <path
          d="M6.78906 11.4998L3.41406 8.12478L4.67646 6.86238L6.81426 9.01277L11.3515 4.47498L12.5893 5.70018L6.78906 11.4998Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
});

TickedCircle.displayName = "Warning";

export default TickedCircle;
